import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get1099MiscBatches: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/batches`,
        isArray: true
    },
    get1099MiscBatch: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/batches/:id`
    },
    get1099MultipleBatches: {
        method: 'POST',
        url: `${BASE_PATH_API}/misc1099/batches/multiple`,
        isArray: true
    },
    delete1099MiscBatch: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/misc1099/:batchId`
    },
    getRentalRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/rentals/recipients`,
        isArray: true
    },
    getAssociationPayers: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/associations/payers`,
        isArray: true
    },
    getAssociationRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/associations/:buildingId/recipients`,
        isArray: true
    },
    getRentalPayer: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/rentals/payer`,
        isArray: true
    },
    isEfilingEnabled: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/isEfilingEnabled`
    },
    getCurrentTaxYear: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/taxYear`
    },
    createBatches: {
        method: 'POST',
        url: `${BASE_PATH_API}/misc1099/batches`
    },
    updateBatch: {
        method: 'PUT',
        url: `${BASE_PATH_API}/misc1099/:batchId`
    },
    getShippingCharges: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/shippingCharges`
    },
    transmitAndSubmit1099MiscBatch: {
        method: 'POST',
        url: `${BASE_PATH_API}/misc1099/efile`
    },
    getFinancialStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/financialStatus`,
        isArray: true
    },
    get1099MiscSavedBatches: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/batches/efile`
    },
    efile1099MiscSavedBatches: {
        method: 'POST',
        url: `${BASE_PATH_API}/misc1099/batches/efile`
    },
    getAssociationsProperties: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/associationProperties`,
        isArray: true,
        cache: true
    },
    getBatchForPayer: {
        method: 'GET',
        url: `${BASE_PATH_API}/misc1099/batches?taxId=:taxId`
    },
    downloadReport: {
        method: 'POST',
        url: `${BASE_PATH_API}/misc1099/rentals/recipients/export?fromDate=:startDate&toDate=:endDate`
    },
    getCsvData: {
        method: 'POST',
        url: `${BASE_PATH_API}/misc1099/recipientsCsvData`
    }
};

export function Misc1099Api() {
    return createActions(actions);
}
